// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.helpTopContainer h2 {
    font-size: 2em;
    color: white;
}

.helpBottomContainer p {
    text-align: center;
    font-size: 0.8em;
}

.helpBottomContainer a {
    text-decoration: none;
}

.privacyPolicyAndEulaLinkWrapper {
    display: flex;
    justify-content: center;
    gap: 2em;
}

.privacyPolicyAndEulaLinks {
    color: var(--Gray);
    opacity: 1;
    font-weight: bold;
}


.privacyPolicyAndEulaLinks:hover {
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Help/HelpContent/HelpContent.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;AACrB;;;AAGA;IACI,eAAe;AACnB","sourcesContent":[".helpTopContainer h2 {\n    font-size: 2em;\n    color: white;\n}\n\n.helpBottomContainer p {\n    text-align: center;\n    font-size: 0.8em;\n}\n\n.helpBottomContainer a {\n    text-decoration: none;\n}\n\n.privacyPolicyAndEulaLinkWrapper {\n    display: flex;\n    justify-content: center;\n    gap: 2em;\n}\n\n.privacyPolicyAndEulaLinks {\n    color: var(--Gray);\n    opacity: 1;\n    font-weight: bold;\n}\n\n\n.privacyPolicyAndEulaLinks:hover {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
